import { render, staticRenderFns } from "./DLDuplicatedEmails.vue?vue&type=template&id=58b80539&scoped=true&"
import script from "./DLDuplicatedEmails.vue?vue&type=script&lang=js&"
export * from "./DLDuplicatedEmails.vue?vue&type=script&lang=js&"
import style0 from "./DLDuplicatedEmails.vue?vue&type=style&index=0&id=58b80539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b80539",
  null
  
)

export default component.exports